export const comments_5618939 = {"data":{"data":[],"links":{}}}